import { isStringEmpty } from "@/common/validation-checkers";
import ISelectOption from '@/models/generic/iselect-option';

interface IProps {
    value?: number;
    values: ISelectOption[];
    purpose: string;
    newValue: (val: string | number | undefined) => void;
}

const DropdownComponent: React.FC<IProps> = ({value, values, purpose, newValue}) => {

    return (
        <div className="mx-4 mt-1">
            <label className='py-1 block text-gray-200 text-md' htmlFor={purpose}>{purpose}</label>
            <select 
                id={purpose}
                className="text-black px-2 py-1 block w-full h-8"
                value={value || ""}
                onChange={(event) => isStringEmpty(event.target.value) ? newValue(undefined) : newValue(event.target.value) }
            >
                <option value={""}>
                    Please select an option
                </option>

                {values.map(x => {
                    return (
                        <option key={x.id} value={x.id}>
                            {x.name}
                        </option>
                    );
                })}
            </select>
        </div>
    )
}

export default DropdownComponent;